(function() {

    'use strict';

    angular.module('app').config(accountingUrlConfig);

    accountingUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function accountingUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/unprocessed-shipment-details/:shipmentId', {
            templateUrl: '/templates/pages/accounting/shipment-details.html',
            controller: 'AccountingShipmentDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'accounting-unprocessed-shipments',
                subParent: 'unprocessed-shipments',
                htmlTitle: 'Invoiced Shipment Details',
                pageTitle: 'Invoiced Shipment Details',
            }
        }).

        // INVOICES
        when('/accounting-invoices', {
            templateUrl: '/templates/pages/accounting.html',
            controller: 'AccountingController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-calculator', 
                parent: 'accounting-unprocessed-shipments', 
                subParent: 'unprocessed-invoices',
                htmlTitle: 'Unprocessed Invoices',
                pageTitle: 'Unprocessed Invoices',
            }
        }).
        when('/accounting/invoices/:id', {
            templateUrl: '/templates/pages/accounting/invoice-details.html',
            controller: 'AccountingInvoiceDetailsController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-calculator',
                parent: 'accounting-unprocessed-shipments',
                subParent: 'unprocessed-invoices',
                htmlTitle: 'Carrier Invoice Details',
                pageTitle: 'Carrier Invoice Details'
            }
        }).
        when('/accounting/invoices/:id/import', {
            templateUrl: '/templates/pages/accounting/invoice-import.html',
            controller: 'AccountingInvoiceImportController',
            controllerAs: 'vm',
            params: {
                icon: 'fa fa-calculator',
                parent: 'accounting-unprocessed-shipments',
                subParent: 'unprocessed-invoices',
                htmlTitle: 'Import CSV',
                pageTitle: 'Import CSV', 
                deepMenuParent: {
                    itemText: 'Carrier Invoice Details',
                    url: '/accounting/invoices/:id', 
                }
            }
        }).
        when('/accounting/invoices/shipment-details/:shipmentId', {
            templateUrl: '/templates/pages/accounting/shipment-details.html',
            controller: 'AccountingShipmentDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'accounting-unprocessed-shipments',
                subParent: 'unprocessed-invoices',
                htmlTitle: 'Invoiced Shipment Details',
                pageTitle: 'Invoiced Shipment Details',
                deepMenuParent: {
                    itemText: 'Carrier Invoice Details',
                    url: '/accounting/invoices/:id', 
                }
            }
        }).

        // SURCHARGES
        when('/accounting/surcharges', {
            templateUrl: '/templates/pages/accounting/surcharges.html',
            controller: 'AccountingSurchargesController',
            controllerAs: 'vm',
            params: {
                parent: 'accounting-unprocessed-shipments',
                htmlTitle: 'Accounting - Surcharges',
                pageTitle: 'Accounting - Surcharges'
            }
        }).
        when('/accounting/surcharges/:id', {
            templateUrl: '/templates/pages/accounting/surcharge-profile-details.html',
            controller: 'AccountingSurchargeProfileDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'accounting-unprocessed-shipments',
                subParent: 'surcharges',
                htmlTitle: 'Accounting - Surcharge Profile Details',
                pageTitle: 'Accounting - Surcharge Profile Details'
            }
        }).

        // ACCOUNTS PAYABLE
        when('/accounting/accounts-payable', {
            templateUrl: '/templates/pages/accounts-payable.html',
            controller: 'AccountsPayableController',
            controllerAs: 'vm',
            params: {
                parent: 'accounting-unprocessed-shipments', 
                htmlTitle: 'Accounts Payable', 
                pageTitle: 'Accounts Payable',
            }
        }).
        when('/accounting/accounts-payable/:id', {
            templateUrl: '/templates/pages/accounting/accounts-payable-details.html',
            controller: 'AccountsPayableDetailsController',
            controllerAs: 'vm',
            params: {
                itemText: 'Accounts Payable Details',
                htmlTitle: 'Accounts Payable Details',
                pageTitle: 'Accounts Payable Details',
                icon: 'fa fa-tag',
                parent: 'accounting-unprocessed-shipments',
                subParent: 'accounts-payable'
            }
        }).
        when('/accounting/accounts-payable/shipment/:shipmentId', {
            templateUrl: '/templates/pages/accounting/shipment-details.html',
            controller: 'AccountingShipmentDetailsController',
            controllerAs: 'vm',
            params: {
                itemText: 'Accounts Payable Shipment Details',
                htmlTitle: 'Accounts Payable Shipment Details',
                pageTitle: 'Accounts Payable Shipment Details',
                icon: 'fa fa-tag',
                parent: 'accounting-unprocessed-shipments', 
                subParent: 'accounts-payable', 
                deepMenuParent: {
                    itemText: 'Accounts Payable Details',
                    url: '/accounting/accounts-payable/:id',
                }
            }
        });
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }
})();



// WEBPACK FOOTER //
// ./js/urls/accounting.js